<template>
  <AppDeleteModal
    :show="show"
    :title="
      $t('confirm.admin.title', {
        userName: resolvedUserName
      })
    "
    keypath="confirm.admin.message"
    @on-confirm="onConfirm"
    @on-close="onClose"
  >
    <template #i18n-t:userName>
      {{ adminToDelete.displayName }}
    </template>

    <template #app-dialog:confirm-btn-text>
      {{ $t('action.remove') }}
    </template>
  </AppDeleteModal>
</template>

<script>
import { isEmpty } from 'lodash'
import { defineComponent } from 'vue'

import { objectOrNullProp } from '@/utils/prop-validators'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

export default defineComponent({
  name: 'AdminDeleteModal',

  components: {
    AppDeleteModal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    adminToDelete: {
      required: true,
      validator: v => objectOrNullProp(v)
    }
  },

  emits: { 'on-confirm': null, 'on-close': null },

  computed: {
    resolvedUserName() {
      if (isEmpty(this.adminToDelete)) return this.$t('roles.user')

      return this.adminToDelete.displayName.split(' ')[0]
    }
  },

  methods: {
    onClose() {
      this.$emit('on-close')
    },

    onConfirm() {
      this.$emit('on-confirm')
    }
  }
})
</script>

<style lang="scss" scoped></style>
